import React from 'react';
import CancellationDetailsModal from './CancellationDetailsModal';
import CancellationLossAversionModal from './CancellationLossAversionModal';
import CancellationReasonModal from './CancellationReasonModal';
import DowngradeUpsellModal from './DowngradeUpsellModal';

export interface CancelPlanModalProps {}

const CancelPlanModal: React.FC<CancelPlanModalProps> = () => (
  <>
    <CancellationReasonModal />
    <CancellationDetailsModal />
    <DowngradeUpsellModal />
    <CancellationLossAversionModal />
  </>
);

export default CancelPlanModal;
